<template lang="html">


  <div class="wrapper margin-menu">

    <section class="intro column-center -contacto">
      <h2>Contacto</h2>
    </section>

    <section class="breadcrumb">
      <nav class="container row-end">
        <router-link to="/">Inicio</router-link>
        <router-link :to="$t('enlaces.lafundacion')">Contacto</router-link>
      </nav>
    </section>

    <main>

      <div class="container">

        <h2 class="title-intro">
          Comprometidos <strong>con la sociedad</strong>
        </h2>

        <p class="texto-intro -contacto">
          Contacta con nosotros a través de este formulario y nos pondremos en contacto lo antes posible.
        </p>

      </div>


      <div class="white-box">
        <div class="container row-start">
          <h2 class="big-title -contacto">Contacta</h2>
        </div>
        <div class="red-border-box -contacto">
          <formulario></formulario>
        </div>
  
      </div>



      <div class="grey-box column-center -tips-contacto">
        <div class="container">
          <div class="tips-contacto row-center ais">
            <article class="tip">
              <div class="contenedor-imagen"><img src="/static/img/icon-localizacion.svg" alt="imagen icono localizacion"></div>
              <p>Avenida de Manoteras nº 24 - 4ª Planta
                28050 Madrid</p>
            </article>
            <article class="tip -telefono">
              <div class="contenedor-imagen"><img src="/static/img/icon-telefono.svg" alt="imagen icono telefono"></div>
              <p><a href="tel:912035500">91 203 55 00</a></p>
            </article>
            <article class="tip">
              <div class="contenedor-imagen"><img src="/static/img/icon-mail.svg" alt="imagen icono mail"></div>
              <p><a href="mailto:webmaster@corporacionpascual.com">webmaster@corporacionpascual.com</a></p>
            </article>
          </div>
        </div>
      </div>



    </main>

  </div>

</template>

<script lang="js">

  import formulario from '@/components/view-parts/contacto/formulario';
  
  export default {
    name: 'contacto',
    components : {
      'formulario' : formulario
    }
  }
    
  </script>


<style lang="scss">
  
  </style>


// WEBPACK FOOTER //
// src/components/views/contacto.vue